import Color from '@/Enums/Color.enum';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import type { ChipProps } from '@mui/material';

export const ActiveStatusProps: ChipProps = {
  label: 'Active',
  sx: {
    color: Color.AccentGreen,
    background: Color.SemiTransparentLightGreen,
  },
  icon: <CheckCircleOutline />,
};

export const CompletedStatusProps: ChipProps = {
  label: 'Completed',
  sx: {
    color: Color.Primary,
    background: Color.PrimaryBackgroundTransparent,
  },
  icon: <CheckCircleOutline />,
};

export const InactiveStatusProps: ChipProps = {
  label: 'Inactive',
  sx: {
    color: Color.AccentRed,
    background: Color.SemiTransparentRed,
  },
};

export const DraftStatusProps: ChipProps = {
  label: 'Draft',
  sx: {
    color: Color.WarningText,
    background: Color.WarningBackground,
  },
};

export const ApprovalRequiredProps: ChipProps = { ...InactiveStatusProps, label: 'Approval Required' };

export const PartialStatusProps: ChipProps = {
  label: 'Partial',
  sx: {
    color: Color.WarningText,
    background: Color.WarningBackground,
  },
  icon: <ErrorOutline />,
};

export const RunningStatusProps: ChipProps = {
  label: 'Running',
  sx: {
    color: '#295BFF',
    background: 'rgb(41 91 255 / 0.12)',
  },
  icon: <CircularProgress size={12} sx={{ color: '#295BFF' }} />,
};

export const getActiveInactiveStatusProps = (
  isActive: boolean,
  activeLabel = 'Active',
  inactiveLabel = 'Inactive',
): ChipProps =>
  isActive ? { ...ActiveStatusProps, label: activeLabel } : { ...InactiveStatusProps, label: inactiveLabel };
